import {AdminHomeView} from "./AdminHomeView";
import * as React from "react";
import {useEffect, useState} from "react";
import {Box} from "@variocube/app-api";
import {BoxView} from "./BoxView";

export interface AdminViewProps {
    onClose: () => void;
}

export function AdminView({onClose}: AdminViewProps) {
    const [box, setBox] = useState<Box>();

    useEffect(() => {
        setBox(undefined);
    }, []);


    if (box) {
        return (
            <BoxView box={box} onBack={() => setBox(undefined)} />
        )
    }
    return (
        <AdminHomeView onOpenBox={setBox} onDone={onClose} />
    );
}